<template>
  <FmPageLayout navbar :search="false">
    <template #navbar-start>
      <FmIcon name="tdesign:chevron-left" @click="back" class="color-[#fff] text-26px"></FmIcon>
    </template>
    <div class="bg-white min-h-screen pb-20">
      <!-- <van-nav-bar
        title="资讯详情"
        left-arrow
        fixed
        placeholder
        @click-left="$router.back()"
        class="bg-blue-600"
      >
        <template #right><van-icon name="share-o" size="18" /></template>
      </van-nav-bar> -->

      <div class="p-4">
        <h1 class="text-xl font-bold leading-tight mb-2">
          精锋医疗- B(02675.HK)公开发售获149.9518倍超购
        </h1>
        <div class="text-xs text-gray-400 mb-4">
          来源：LiveReport大数据 17:34
        </div>

        <div class="bg-gray-50 rounded-lg p-3 mb-6 flex flex-col gap-2">
          <div v-for="i in 2" :key="i" class="flex justify-between items-center">
            <div class="flex items-center gap-1">
              <van-tag type="primary" >延</van-tag>
              <span class="text-blue-500 text-sm">恒生指数(HSI.HK)</span>
            </div>
            <div class="flex gap-4">
              <span class="text-red-500 font-bold">26338.47</span>
              <span class="text-red-500">+2.76%</span>
            </div>
          </div>
        </div>

        <div class="text-[15px] text-gray-700 leading-relaxed mb-6">
          精锋医疗- B(02675.HK) 截止目前孖展金额为180.9524亿港元...
        </div>

        <div class="font-bold text-gray-800 mb-3">券商孖展（亿元）</div>
        <div class="space-y-3">
          <div v-for="(val, name) in brokers" :key="name" class="flex justify-between text-sm">
            <span class="text-gray-600">{{ name }}</span>
            <div class="flex gap-2">
              <span class="font-medium">{{ val.amount }}</span>
              <span class="text-gray-400">(息率{{ val.rate }})</span>
            </div>
          </div>
        </div>
      </div>

      <div class="fixed bottom-0 left-0 right-0 p-3 bg-white border-t flex items-center gap-3">
        <van-field
          v-model="comment"
          placeholder="我也来说两句~"
          class="bg-gray-100 rounded-full py-1 flex-1"
        />
        <div class="flex gap-4 text-gray-400">
          <div class="flex flex-col items-center"><van-icon name="share-o" /> <span class="text-[10px]">0</span></div>
          <div class="flex flex-col items-center"><van-icon name="good-job-o" /> <span class="text-[10px]">0</span></div>
          <div class="flex flex-col items-center"><van-icon name="star-o" /></div>
        </div>
      </div>
    </div>
  </FmPageLayout>
</template>

<script setup lang="ts">

definePage({
  name: 'news-detail',
  meta: {
    title: '咨询详情',
  },
})

const comment = ref('');
const brokers = {
  '富途证券': { amount: '85.1300', rate: '0.00%' },
  '辉立证券': { amount: '62.0000', rate: '0.00%' },
  '老虎国际': { amount: '14.7980', rate: '0.00%' },
  '华泰国际': { amount: '6.9510', rate: '3.60%' }
};

const router=useRouter()
const back=()=>{
  router.back()
}
</script>

<style scoped>
:deep(.van-nav-bar__title) { color: white; }
:deep(.van-nav-bar .van-icon) { color: white; }
</style>
